import React from 'react';

import '../../assets/styles/style.css';
import comInfoBackg from '../../assets/images/company-info-bak.jpeg'
import {useTranslation} from "react-i18next";
import comTopImg from '../../assets/images/com_info_2.jpg'
import comFrameImg from '../../assets/images/com-info-frame.png'
import TopBanner from "../../components/TopBanner";

const CompanyInfo: React.FC<any> = () => {
    const {t} = useTranslation();

    return (
        <>
            <div className="description">
                <main>
                    <TopBanner image={comInfoBackg} title={t('header:btn_company_info')} altText={t('header:btn_company_info')} textColor={'white'}/>
                    {/*<div className="subpage-banner  bg-cover relative text-white font-primary">*/}
                    {/*    <img src={comInfoBackg} alt="company info" className="w-full align-middle h-96 object-cover object-center lg:h-auto"/>*/}
                    {/*    <div className="banner-description-v2 container mx-auto absolute right-0 left-0 z-10">*/}
                    {/*        <h2 className="text-3xl md:text-4xl lg:text-6xl xl:text-100 font-bold relative font-primary">{t('header:btn_company_info')}</h2>*/}
                    {/*    </div>*/}
                    {/*    <div className="overlay absolute bg-overlay-0"></div>*/}
                    {/*</div>*/}
                    <section className="img-des pt-16 pb-8 xl:pt-32 xl:pb-16">
                        <div className="img-des-container container mx-auto">
                            <div className="img-des-pic mb-8 xl-custom-1366:mb-14">
                                <img src={comTopImg} alt="com info top image" className="w-full align-middle"/>
                            </div>
                            <div className="img-des-txt text-primary">
                                <h2 className="text-xl lg:text-2xl xl-custom-1280:text-3xl 4xl-custom:text-5xl text-primary font-primary">{t('company:info.one.title')}</h2>
                                <p className="text-base lg:text-lg mt-4 pl-4 relative lg:pl-8 font-primary">
                                    {t('company:info.one.content')}
                                </p>
                            </div>
                        </div>
                    </section>
                    <section className="two-col-content pt-8 pb-16 xl:pt-16 xl:pb-32">
                        <div className="two-col-container container mx-auto">
                            <div className="two-col-list">

                                <div className="two-col-item  flex flex-col md:items-center mb-16 xl:mb-32">
                                    <div className="two-col-img">
                                        <img src={comFrameImg} alt="com info second img" className="w-full align-middle"/>
                                    </div>
                                    <div className="two-col-desc mt-8 lg-normal:mt-0 lg-normal:ml-8 xl-custom-1280:ml-16">
                                        <h3 className="two-col-title text-secondary text-xl lg:text-2xl xl-custom-1280:text-3xl 4xl-custom:text-5xl font-primary">{t('company:info.two.title')}</h3>
                                        <p className="two-col-txt text-primary text-base lg:text-lg mt-4 font-primary ">
                                            {t('company:info.two.content')}
                                        </p>
                                    </div>
                                </div>

                                <div className="two-col-item two-col-item-reverse flex flex-col md:items-center mb-16 xl:mb-32">
                                    <div className="two-col-img">
                                        <img src={comFrameImg} alt="ccc" className="w-full align-middle"/>
                                    </div>
                                    <div className="two-col-desc mt-8 lg-normal:mt-0 lg-normal:ml-8 xl-custom-1280:ml-16">
                                        <h3 className="two-col-title text-secondary text-xl lg:text-2xl xl-custom-1280:text-3xl 4xl-custom:text-5xl font-primary"> {t('company:info.three.title')}</h3>
                                        <p className="two-col-txt text-primary text-base lg:text-lg mt-4 font-primary ">
                                            {t('company:info.three.content')}
                                        </p>
                                    </div>
                                </div>


                            </div>

                            <div className="realtive w-full flex items-center justify-end">
                                <a href="/contact-us" className="two-col-link view-more font-bold font-primary text-primary text-xl lg:text-2xl xl-custom-1280:text-3xl 4xl-custom:text-5xl">
                                    <span className="block">{t('company:info.letTalk')}</span> <span
                                    className="block xl-custom-1440:whitespace-nowrap whitespace-normal">{t('company:info.haHelp')}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="125" height="49.064" viewBox="0 0 125 49.064"
                                         className="ml-auto mr-2 mt-0 xl:mt-4 translate-x-0 transition-all duration-300 w-16 h-auto lg:w-20 xl:w-28">
                                        <g id="Icon_feather-arrow-right" data-name="Icon feather-arrow-right" transform="translate(2.5 3.532)">
                                            <path id="Path_26" data-name="Path 26" d="M7.5,18h120" transform="translate(-7.5 3)" fill="none" stroke="blue" stroke-linecap="round"
                                                  stroke-linejoin="round" stroke-width="5"></path>
                                            <path id="Path_27" data-name="Path 27" d="M18,7.5l19.24,21L18,49.5" transform="translate(82.76 -7.5)" fill="none" stroke="blue" stroke-linecap="round"
                                                  stroke-linejoin="round" stroke-width="5"></path>
                                        </g>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        </>
    );
}

export default CompanyInfo;